import { Component, computed, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-enter-code-form',
  imports: [FormsModule],
  templateUrl: './enter-code-form.html',
  styleUrl: './enter-code-form.scss',
})
export class EnterCodeForm {
  recoveryEmail = input.required<string>();

  codeDigit1 = signal('');
  codeDigit2 = signal('');
  codeDigit3 = signal('');
  codeDigit4 = signal('');
  codeDigit5 = signal('');
  codeDigit6 = signal('');

  changeView = output<'login' | 'reset-password'>();
  codeVerified = output<string>();

  recoveryCode = computed(() =>
    `${this.codeDigit1()}${this.codeDigit2()}${this.codeDigit3()}${this.codeDigit4()}${this.codeDigit5()}${this.codeDigit6()}`
  );

  verifyCode() {
    console.log(`Verifying code: ${this.recoveryCode()}`);
    // In a real app, you'd validate the code via a service.
    if (this.recoveryCode().length === 6) {
      this.codeVerified.emit(this.recoveryCode());
    }
  }

  handleCodeInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const digitSignals = [
      this.codeDigit1,
      this.codeDigit2,
      this.codeDigit3,
      this.codeDigit4,
      this.codeDigit5,
      this.codeDigit6
    ];

    // Handle paste
    if (value.length > 1) {
      for (let i = 0; i < Math.min(value.length, 6); i++) {
        digitSignals[i].set(value[i]);
      }
      const nextFocusIndex = Math.min(value.length, 6);
      const nextEl = document.getElementById(`recoveryCode${nextFocusIndex}`);
      nextEl?.focus();
      return; // Stop further processing for paste
    }

    // Move to next input on digit entry
    if (value.length === 1 && index < 6) {
      const nextEl = document.getElementById(`recoveryCode${index + 1}`);
      nextEl?.focus();
    }
  }

  handleCodeKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    // Move to previous on backspace if current is empty
    if (event.key === 'Backspace' && input.value === '' && index > 1) {
      const prevEl = document.getElementById(`recoveryCode${index - 1}`);
      prevEl?.focus();
    }
  }
}
